import {commonEn, commonRu} from '@/core/locales/common';
import {filtersEn, filtersRu} from '@/core/locales/filters';
import {ltdRu, ltdEn} from '@/core/locales/charts/ltd';

export default {
    en: {
        ...commonEn,
        filters: filtersEn,
        charts: {
            ltd: ltdEn,
        },
    },
    ru: {
        ...commonRu,
        filters: filtersRu,
        charts: {
            ltd: ltdRu,
        },
    },
};
